import React, { useEffect } from "react";

const VerticalTimeline = ({ timelineData, timelineDes }) => {
    useEffect(() => {
        const timelineBlocks = document.querySelectorAll(".timeline-block");

        const checkTimelineScroll = () => {
            timelineBlocks.forEach((block) => {
                const blockTop = block.getBoundingClientRect().top;
                const blockHeight = block.offsetHeight;
                const windowHeight = window.innerHeight;

                if (blockTop <= windowHeight - blockHeight / 4) {
                    block.classList.add("animate");
                }
            });
        };

        window.addEventListener("scroll", checkTimelineScroll);
        window.addEventListener("resize", checkTimelineScroll);
        checkTimelineScroll();

        return () => {
            window.removeEventListener("scroll", checkTimelineScroll);
            window.removeEventListener("resize", checkTimelineScroll);
        };
    }, []);

    return (
        <div className="timeline-container">
            {/* Dynamic Style Tag Generation */}
            <style>
                {timelineData.map((item, index) => {
                    const sideColor = item.side_color;
                    const isEven = index % 2 === 0;
                    return `
      .timeline-content.dynamic-content-${index}::before {
          content: "";
          position: absolute;
          top: 70px;
          ${isEven ? 'left: -8px;' : 'right: -8px;'}
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 10px 10px 10px 0;
          border-color: ${sideColor} !important;
          z-index: 2 !important;
      }
      .timeline-content.dynamic-content-${index}::after {
          content: "";
          position: absolute;
          top: 78px;
          ${isEven ? 'left: -80px;' : 'right: -80px;'}
          width: 80px;
          height: 4px;
          background-color: ${sideColor} !important;
          z-index: 0 !important;
      }
           /* Hide ::after on mobile */
        @media (max-width: 768px) {
            .timeline-content.dynamic-content-${index}::after {
                display: none !important;
            }
        }
    `;
                }).join('\n')}  
            </style>
            <div className="title-bx ">
                <h2 className="sub-title them-font fw-bold">
                    {timelineDes?.title}
                </h2>
                <div className="des them-font px-3 px-md-0 px-sm-3"
                    dangerouslySetInnerHTML={{ __html: timelineDes?.description }}
                />
            </div>
            <div className="timeline">
                {timelineData.map((item, index) => {
                    const bgColorWithOpacity = item.background_color + '4D'; // 30% opacity
                    const sideColor = item.side_color;

                    return (
                        <div
                            className={`timeline-block ${index % 2 === 0 ? "left" : "right"}`}
                            key={index}
                        >
                            <div
                                className="timeline-img"
                                style={{ boxShadow: `0 0 15px ${sideColor}` }}
                            >
                                <img src={item.image} alt="image" className="timeline-img-2" />
                            </div>

                            <div className={`timeline-content-wrapper ${index % 2 === 0 ? "timelineleft" : "timelineright"}`}>
                                <div
                                    className={`timeline-content dynamic-content-${index}`}
                                    style={{
                                        backgroundColor: bgColorWithOpacity,
                                        boxShadow: `inset ${index % 2 === 0 ? '6px' : '-6px'} 0px 2px ${sideColor}`
                                    }}
                                >
                                    <span className="timeline-date timeline-date-0 mb-3" style={{ background: item.background_color }}>{item.title}</span>
                                    <h2>{item.sub_title}</h2>
                                    <p>{item.description}</p>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default VerticalTimeline;
